/**
 * SIDEBAR
 */
export const sidebarActionTypes = {
  FETCH_SIDEBAR_DATA_START: "FETCH_SIDEBAR_DATA_START",
  FETCH_SIDEBAR_DATA_ERROR: "FETCH_SIDEBAR_DATA_ERROR",
  FETCH_SIDEBAR_DATA_SUCCESS: "FETCH_SIDEBAR_DATA_SUCCESS",
  SET_SIDEBAR_PLAYLISTS: "SET_SIDEBAR_PLAYLISTS",
  TOGGLE_SIDEBAR_VISIBILITY: "TOGGLE_SIDEBAR_VISIBILITY",
};
